import React from "react";
import "./LeagueLandingPage.css";
import LeagueHero from "./league/LeagueHero";

const standings = [
  ["1", "MB", "Mowbray", "10", "↑ 2"],
  ["2", "DS", "District Six", "5", "– 0"],
  ["3", "KR", "Kuils River", "3", "↓ 1"],
  ["4", "PR", "Parow", "1", "↑ 3"],
  ["5", "SD", "Strand", "0", "↓ 1"],
];

const effect = [
  ["▥", "Performance", "Improve daily execution."],
  ["♙", "Engagement", "Teams get motivated to compete."],
  ["♜", "Recognition", "Top performers get rewarded."],
  ["⬡", "Accountability", "Everyone takes ownership."],
  ["✓", "Consistency", "Better habits. Better results."],
  ["☆", "Culture", "A winning culture becomes the norm."],
  ["▥", "Growth", "Stronger operations. Stronger business."],
];

const features = [
  ["▣", "Seasonal Leagues", "Run time-bound seasons with promotions and relegations."],
  ["⚑", "Friendly Competition", "Sites compete across real operational competitions."],
  ["♜", "Live Standings", "Real-time points, movement, wins, and form."],
  ["◉", "Rewards & Recognition", "Celebrate winners and top performers every season."],
  ["✪", "Hall of Fame", "Honor champions and build pride across the organization."],
];

const steps = [
  ["1", "Plan & Set Up", "Create the season, add sites, define competitions and rules."],
  ["2", "Launch Competitions", "Run operational challenges that drive real performance."],
  ["3", "Track & Score", "Capture results and award points automatically."],
  ["4", "Climb the Table", "Sites compete, climb the standings, and build momentum."],
  ["5", "Celebrate Winners", "Champions are recognized and remembered."],
];

function Brand() {
  return (
    <a className="league-brand" href="/matrixos-enter" aria-label="MatrixOS ecosystem">
      <span className="league-brand-mark">M</span>
      <span><b>MATRIXOS</b><strong>LEAGUE</strong></span>
    </a>
  );
}

function StandingsCard({ compact = false }) {
  return (
    <div className={`league-board ${compact ? "is-compact" : ""}`}>
      <div className="league-board-head">
        <div>
          <span>Silver League</span>
          <strong>Standings</strong>
        </div>
        <button type="button" onClick={() => window.location.href = "/login?app=league"}>View full table →</button>
      </div>
      <div className="league-table-head"><span>#</span><span>Site</span><span>Points</span><span>Trend</span></div>
      {standings.map(([rank, initials, site, points, trend], index) => (
        <div className={`league-table-row ${index === 0 ? "is-first" : ""}`} key={site}>
          <span>{rank}</span>
          <span className="league-site"><i>{initials}</i>{site}</span>
          <b>{points}</b>
          <span className={trend.includes("↑") ? "up" : trend.includes("↓") ? "down" : "flat"}>{trend}</span>
        </div>
      ))}
    </div>
  );
}

function Trophy() {
  return (
    <div className="league-trophy-wrap" aria-hidden="true">
      <div className="league-confetti" />
      <div className="league-trophy">
        <div className="league-cup-handles"><i /><i /></div>
        <div className="league-cup"><span>M</span></div>
        <div className="league-cup-stem" />
        <div className="league-cup-base"><small>EXCELLENCE<br/>IS EARNED</small></div>
      </div>
    </div>
  );
}

export default function LeagueLandingPage() {
  return (
    <main className="league-page">
      <LeagueHero />

      <section className="league-effect-section">
        <div className="league-section-kicker">The League Effect</div>
        <div className="league-effect-row">
          {effect.map(([icon, title, copy], index) => (
            <React.Fragment key={title}>
              <div className="league-effect-item"><b>{icon}</b><strong>{title}</strong><span>{copy}</span></div>
              {index < effect.length - 1 && <i className="league-arrow">→</i>}
            </React.Fragment>
          ))}
        </div>
      </section>

      <section className="league-section" id="features">
        <h2>Turn operations into a competitive advantage.</h2>
        <div className="league-feature-grid">
          {features.map(([icon, title, copy]) => <article key={title}><b>{icon}</b><h3>{title}</h3><p>{copy}</p></article>)}
        </div>
      </section>

      <section className="league-showcase" id="standings">
        <div className="league-showcase-copy">
          <span className="league-section-kicker left">Real competitions. Real impact.</span>
          <h2>Compete, climb,<br/>and become the best.</h2>
          <p>Run seasonal competitions, track live results, and see who is leading the league.</p>
          <ul>
            <li>Operational competitions with real impact</li>
            <li>Live standings and performance tracking</li>
            <li>Promotions and relegations</li>
            <li>Hall of Fame and achievement history</li>
            <li>Custom competitions and scoring</li>
            <li>Export leaderboards and reports</li>
          </ul>
        </div>
        <div className="league-laptop">
          <div className="league-app-bar"><Brand /><span>Overview</span><span className="selected">Standings</span><span>Events</span><span>Archive</span><button>The Venue Cape Town⌄</button></div>
          <div className="league-app-content"><StandingsCard /><div className="league-stat-row"><div><small>League health</small><b>92%</b><span>Active sites</span></div><div><small>Season progress</small><b>35%</b><span>Time elapsed</span></div><div><small>Top performer</small><b>Mowbray</b><span>10 operational points</span></div><div><small>Latest winner</small><b>Mowbray</b><span>Inventory Accuracy</span></div></div></div>
        </div>
      </section>

      <section className="league-how" id="how">
        <span className="league-section-kicker">How it works</span>
        <h2>Simple. Fair. Transparent.</h2>
        <div className="league-steps">
          {steps.map(([num, title, copy], index) => <React.Fragment key={title}><article><b>{num}</b><h3>{title}</h3><p>{copy}</p></article>{index < steps.length - 1 && <i>······→</i>}</React.Fragment>)}
        </div>
      </section>

      <section className="league-cta" id="hall">
        <div className="league-cta-mark">M</div>
        <div><h2>Ready to build a winning culture?</h2><p>Join MatrixOS League and turn everyday operations into championship performance.</p></div>
        <div><a className="league-primary-button" href="/login?app=league">Explore League →</a><a className="league-video-button" href="/book-demo?product=league">Book a demo</a></div>
      </section>

      <footer>© 2026 MatrixOS. Operate with Clarity.</footer>
    </main>
  );
}
